export default function PartnershipSection() {
  return (
    <section id="partnership" className="py-20 bg-gradient-to-b from-white to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Nhượng quyền & <span className="text-orange-600">Hợp tác</span></h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">Mô hình hợp tác linh hoạt dành cho các trường học, trung tâm đào tạo và đơn vị giáo dục muốn triển khai chương trình Robotics & AI chuyên nghiệp</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-gift-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">ESAPCOR cung cấp</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-orange-50 rounded-lg p-4 hover:bg-orange-100 transition-colors">
                <div className="flex items-start">
                  <i className="ri-book-2-line text-2xl text-orange-600 mr-3 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm">Giáo trình độc quyền</h4>
                    <p className="text-xs text-gray-600">Chương trình đào tạo chuẩn STEAM được cập nhật liên tục</p>
                  </div>
                </div>
              </div>
              <div className="bg-orange-50 rounded-lg p-4 hover:bg-orange-100 transition-colors">
                <div className="flex items-start">
                  <i className="ri-box-3-line text-2xl text-orange-600 mr-3 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm">Robotics Kits</h4>
                    <p className="text-xs text-gray-600">Cung cấp đầy đủ thiết bị và linh kiện với giá ưu đãi</p>
                  </div>
                </div>
              </div>
              <div className="bg-orange-50 rounded-lg p-4 hover:bg-orange-100 transition-colors">
                <div className="flex items-start">
                  <i className="ri-graduation-cap-line text-2xl text-orange-600 mr-3 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm">Đào tạo giảng viên</h4>
                    <p className="text-xs text-gray-600">Chương trình đào tạo và cấp chứng chỉ cho giáo viên</p>
                  </div>
                </div>
              </div>
              <div className="bg-orange-50 rounded-lg p-4 hover:bg-orange-100 transition-colors">
                <div className="flex items-start">
                  <i className="ri-megaphone-line text-2xl text-orange-600 mr-3 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm">Hỗ trợ Marketing</h4>
                    <p className="text-xs text-gray-600">Tài liệu quảng bá, chiến dịch marketing và branding</p>
                  </div>
                </div>
              </div>
              <div className="bg-orange-50 rounded-lg p-4 hover:bg-orange-100 transition-colors">
                <div className="flex items-start">
                  <i className="ri-settings-3-line text-2xl text-orange-600 mr-3 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm">Quy trình vận hành</h4>
                    <p className="text-xs text-gray-600">Hệ thống quản lý học viên và vận hành trung tâm</p>
                  </div>
                </div>
              </div>
              <div className="bg-orange-50 rounded-lg p-4 hover:bg-orange-100 transition-colors">
                <div className="flex items-start">
                  <i className="ri-customer-service-2-line text-2xl text-orange-600 mr-3 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm">Hỗ trợ kỹ thuật</h4>
                    <p className="text-xs text-gray-600">Đội ngũ hỗ trợ 24/7 giải đáp mọi thắc mắc</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl p-8 shadow-lg text-white">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-star-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold">Đối tác nhận được</h3>
            </div>
            <ul className="space-y-4">
              <li className="flex items-start bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0"></i>
                <span className="text-lg">Sử dụng thương hiệu ESAPCOR</span>
              </li>
              <li className="flex items-start bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0"></i>
                <span className="text-lg">Quy trình đào tạo chuẩn hóa</span>
              </li>
              <li className="flex items-start bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0"></i>
                <span className="text-lg">Tài liệu giảng dạy đầy đủ</span>
              </li>
              <li className="flex items-start bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0"></i>
                <span className="text-lg">Hỗ trợ tuyển sinh học viên</span>
              </li>
              <li className="flex items-start bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0"></i>
                <span className="text-lg">Cập nhật công nghệ mới nhất</span>
              </li>
              <li className="flex items-start bg-white/10 rounded-lg p-4 backdrop-blur-sm">
                <i className="ri-checkbox-circle-fill text-2xl mr-3 flex-shrink-0"></i>
                <span className="text-lg">Cộng đồng đối tác toàn quốc</span>
              </li>
            </ul>
            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-sm mb-4"><i className="ri-information-line mr-2"></i>Phí nhượng quyền linh hoạt theo quy mô và khu vực</p>
              <button className="whitespace-nowrap w-full bg-white text-orange-600 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors cursor-pointer">
                <i className="ri-phone-line mr-2"></i>Liên hệ tư vấn ngay
              </button>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Quy trình hợp tác đơn giản</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl">01</div>
              <h4 className="font-bold text-gray-900 mb-2">Liên hệ & Tư vấn</h4>
              <p className="text-sm text-gray-600">Gửi thông tin và nhận tư vấn chi tiết về mô hình hợp tác</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl">02</div>
              <h4 className="font-bold text-gray-900 mb-2">Khảo sát & Đánh giá</h4>
              <p className="text-sm text-gray-600">Đội ngũ ESAPCOR khảo sát cơ sở vật chất và đề xuất giải pháp</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl">03</div>
              <h4 className="font-bold text-gray-900 mb-2">Ký kết & Đào tạo</h4>
              <p className="text-sm text-gray-600">Ký hợp đồng và bắt đầu đào tạo giảng viên, setup hệ thống</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl">04</div>
              <h4 className="font-bold text-gray-900 mb-2">Vận hành & Hỗ trợ</h4>
              <p className="text-sm text-gray-600">Chính thức khai giảng với sự hỗ trợ liên tục từ ESAPCOR</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
